import { StatisticsParameters } from '../services/getSystemStatistics';

export const formDataInitialState: StatisticsParameters = {
  from: '',
  to: '',
};
